import React from 'react'
import PropTypes from 'prop-types'
import { useTranslation } from 'react-i18next'
import {
  Dialog,
  DialogActions,
  DialogContent,
  List,
  ListItem,
  ListItemAvatar,
  ListItemText,
  Divider
} from '@mui/material'
import CloseIcon from '@mui/icons-material/Close'
import Avatar from '@mui/material/Avatar'
import EmailOutlinedIcon from '@mui/icons-material/EmailOutlined'
import VisibilityOutlinedIcon from '@mui/icons-material/VisibilityOutlined'
import PermIdentityOutlinedIcon from '@mui/icons-material/PermIdentityOutlined'
import { Logger, LoggerTypes } from '../../../utils'
import { useState } from 'react'
import { getUserInfosFromStorage } from '../../../storage/storage'
import { Button, buttonModes, buttonTypes, FormTitle } from '../../../components'

export const UserProfileDialog = ({ setOpenDialog, className }) => {
  const { t } = useTranslation()

  const [userInfos] = useState(getUserInfosFromStorage())

  const onCloseDialog = () => setOpenDialog(false)

  Logger.trace(LoggerTypes.CONTAINER, 'UserProfileDialog.render()', {})
  return (
    <Dialog
      open={true}
      onClose={onCloseDialog} // <-- close while clicking on background
      aria-labelledby="form-dialog-title"
      maxWidth="xl"
      width="xl"
      className={`SimulationDialogLaunch ${className}`}
    >
      <DialogContent>
        <List
          sx={{
            width: '100%',
            maxWidth: 560,
            bgcolor: 'background.paper'
          }}
        >
          <FormTitle title={t('users.profile.title')} style={{ fontSize: '20px' }} />
          <ListItem>
            <ListItemAvatar>
              <Avatar>
                <PermIdentityOutlinedIcon />
              </Avatar>
            </ListItemAvatar>
            <ListItemText primary={t('users.profile.name')} secondary={userInfos.name} />
          </ListItem>
          <Divider variant="inset" component="li" />
          <ListItem>
            <ListItemAvatar>
              <Avatar>
                <EmailOutlinedIcon />
              </Avatar>
            </ListItemAvatar>
            <ListItemText primary={t('users.profile.email')} secondary={userInfos.email} />
          </ListItem>
          <Divider variant="inset" component="li" />
          <ListItem>
            <ListItemAvatar>
              <Avatar>
                <VisibilityOutlinedIcon />
              </Avatar>
            </ListItemAvatar>
            <ListItemText primary={t('users.profile.rights')} secondary={userInfos.role} />
          </ListItem>
          <Divider variant="inset" component="li" />
        </List>
      </DialogContent>
      <DialogActions>
        <Button
          mode={buttonModes.SECONDARY_ACTION}
          type={buttonTypes.BUTTON}
          text={t('common.close')}
          icon={<CloseIcon />}
          onClick={onCloseDialog}
          className="common_fullwidth"
        />
      </DialogActions>
    </Dialog>
  )
}

UserProfileDialog.displayName = 'UserProfileDialog'

UserProfileDialog.propTypes = {
  setOpenDialog: PropTypes.func.isRequired,
  className: PropTypes.string
}

UserProfileDialog.defaultProps = {
  setOpenDialog: () => {},
  className: ''
}
